<template>
  <div class="fts-form-container" :class="{'px-0': columnSection}" ref="ftsForm">
    <!-- <div class="fts-form-title"></div> -->
    <div 
      class="fts-form-wrapper"
      v-for="row in form != null? form.rows.filter(x => x.items.some(y => show(y) && y.input != 'empty')): []"
      :key="row.index">
      <template v-for="item in row.items">   
        <!-- section -->
        <template v-if="item && item.input === 'section'">
          <div 
            class="fts-form-section" 
            :class="{'form-section-hoverable fts-form-group': item.type !== 'column'}"
            :key="item.id" 
            v-if="sectionVisibility(item)">
            <!-- section header -->
            <div class="form-section-header"
              :class="{ 'form-section-collapsible ': item.type === 'collapse', 'form-section-expanded': item.type === 'collapse' && item.expanded, 'form-section-tab ': item.type === 'tab' }"
              @click="collapseExpand(item)">
              <div class="form-section-header-wrapper">
                <!-- tab title -->
                <template v-if="item.type === 'tab'">
                  <template v-for="tab in item.tabs">
                    <div 
                      class="form-section-header-title"
                      :class="{ 'form-section-tab-selected': tab.selected }"
                      :key="tab.id" @click="selectTab(item, tab)"
                      v-if="sectionVisibility(tab)">
                      {{tab.header? tab.header : 'Tab'}}
                    </div>
                  </template>
                </template>
                <!-- section title -->
                <div class="form-section-header-title" v-else-if="item.type !== 'column'">{{item.header? item.header : '(Untitled)'}}</div>
              </div>
              <!-- section collapse toggle -->
              <div class="form-section-header-action" v-if="item.type == 'collapse'">
                <font-awesome-icon :icon="['fas', 'chevron-down']" />
              </div>
            </div>
            <!-- section content -->
            <fts-transition-expand>
              <template v-if="item.expanded || item.type !== 'collapse'">
                <fts-form 
                  @eventTriggered="triggerEvent"
                  :form="retrieveTabForm(item)"
                  :formData="formData"             
                  :validator="validator"
                  :vectorId="vectorId"
                  :view="view"
                  :columnSection="item.type === 'column'" />
              </template>
            </fts-transition-expand>
          </div>
        </template>
        <!-- form element -->
        <fts-form-element
          @eventTriggered="triggerEvent"
          :item="item"
          :vectorId="vectorId"
          :validator="validator"
          :formData="formData"
          :view="view"
          :context="context"
          :key="item.id"
          :username="username"
          @input="$v.formData.$touch()" 
          v-else-if="show(item)"/>
      </template>
    </div>
  </div>
</template>

<script>
// let resizeObserver = null

import commons from '../commons/commons';

import FTSFormElement from "./FTSFormElement";
import FTSTransitionExpand from "./FTSTransitionExpand";

export default {
  components: {
    "fts-form-element": FTSFormElement,
    "fts-transition-expand": FTSTransitionExpand
  },
  props: {
    form: Object,
    formData: Object,
    validator: Object,
    context: Object,
    vectorId: [String, Number],
    view: Boolean,
    columnSection: Boolean,
    username: String
  },
  data() {
    return {
      enabled: true,
      modal: true
    };
  },
  methods: {
    triggerEvent: function(eventName) {
      this.$emit('eventTriggered', eventName);
    },
    selectTab: function(item, tab) {
      item.tabs.forEach(x => this.$set(x, 'selected', false));
      this.$set(tab, 'selected', true);
    },
    retrieveTabForm: function(item) {
      if(item.type == 'tab') {
        let tabSelected = item.tabs.find(x => x.selected);
        if(tabSelected == null)
          tabSelected = item.tabs[0];
        return tabSelected.design;
      }

      return item.design;
    },
    collapseExpand: function(item) {
      if(item.type === 'collapse') {
        if (!item.expanded)
          this.$set(item, "expanded", false);

        item.expanded = !item.expanded;
      }
    },
    sectionVisibility (item) {
      let vm = this

      function findElement(elements) {
        return elements.some(x => {
          if (x.tabs)
            return findElement(x.tabs)
          if (x.design && x.design.rows)
            return findElement(x.design.rows)
          if (x.items) 
            return findElement(x.items)
          
          return vm.show(x) && x.input != 'empty'
        })
      }

      if (item.visible === false)
        return false;
      else if (item.type === 'tab' && item.tabs)
        return findElement(item.tabs);
      else if (item.design && item.design.rows)
        return findElement(item.design.rows);
    },
    show(item) {
      return commons.formElementVisibility(item, this.formData);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-form-container {
  min-height: 50px;
  &:not(.px-0) {
    padding-left: .75rem;
    padding-right: .75rem;
  }
  .fts-form-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-left: -0.75rem;
    margin-right: -0.75rem;
    .fts-form-section {
      margin-left: .75rem;
      margin-right: .75rem;
    }
    .fts-form-element {
      padding-left: .75rem;
      padding-right: .75rem;
    }
  }

  .fts-form-section {
    width: auto;
    flex: 1 1 400px;
    &.form-section-hoverable {
      border: 1px solid var(--fts-form-control-border);
      .form-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;
        background: var(--fts-gray-1);
        & + .fts-form-container {
          padding-top: 1rem;
        }
        // For Collapse
        &.form-section-collapsible {
          cursor: pointer;
          &.form-section-expanded {
            .form-section-header-action {
              svg {
                transform: rotate(-90deg);
              }
            }
          }
        }
        // For Tab
        &.form-section-tab {
          .form-section-header-wrapper {
            .form-section-header-title {
              padding-left: 1rem;
              padding-right: 1rem;
              color: var(--fts-gray-5);
              &:hover {
                cursor: pointer;
                &:not(.form-section-tab-selected) {
                  @include theme() {
                    background: rgba(theme-get('fts-gray-5'), 0.095);
                  }
                }
              }
              &.form-section-tab-selected {
                color: $primaryColor;
                &:hover {
                  background: rgba($color: $primaryColor, $alpha: .095);
                }
              }
            }
          }
        }
        .form-section-header-wrapper {
          flex: 1;
          display: flex;
          .form-section-header-title {
            padding: .75rem 0;
            font-weight: bold;
            font-size: .875rem;
            line-height: 1.5;
          }
        }
        .form-section-header-action {
          svg {
            transition: transform .3s;
            font-size: .75rem;
          }
        }
      }
    }
  }
}
</style>
